// import React from 'react';
import { Route, Switch } from 'react-router-dom';
import _ from 'lodash';
import { IfmsRoute } from './types';

import InvalidOperation from '../InvalidOperation';
import NotFound from '../NotFound';

import commonRoutes from '../components/common/routes';
import memoListRoutes from '../components/memoList/routes';
import referenceFilesRoutes from '../components/referenceFiles/routes';
import utilitiesRoutes from '../components/Help/routes';
import setupRoutes from '../components/setup/routes';
import accountingRoutes from '../components/accounting/routes';
import airExportRoutes from '../components/airExport/routes';
import airImportRoutes from '../components/airImport/routes';
import oceanExportRoutes from '../components/oceanExport/routes';
import oceanImportRoutes from '../components/oceanImport/routes';
import otherShipmentRoutes from '../components/otherShipment/routes';
import warehousingRoutes from '../components/warehousing/routes';
import homeRoutes from '../components/home/routes';
import opReportRoutes from '../components/opReport/routes';
import brokerageTruckingRoutes from '../components/brokerageTrucking/routes';
import amsRoutes from '../components/ams/routes';
import isfRoutes from '../components/isf/routes';


export const IfmsAppRoutes = [
  ...commonRoutes,
  ...memoListRoutes,
  ...referenceFilesRoutes,
  ...utilitiesRoutes,
  ...setupRoutes,
  ...accountingRoutes,
  ...airExportRoutes,
  ...airImportRoutes,
  ...oceanExportRoutes,
  ...oceanImportRoutes,
  ...otherShipmentRoutes,
  ...warehousingRoutes,
  ...opReportRoutes,
  ...brokerageTruckingRoutes,
  ...amsRoutes,
  ...isfRoutes,

  ...homeRoutes,
];

const routeExpander = (routes:Array<IfmsRoute>) => routes.map( r => <Route exact key={_.uniqueId('route-')} path={r.path} component={r.component} />);

const routes = (
  <Switch>
    {routeExpander(IfmsAppRoutes)}
    <Route path="/invalidOperation" component={InvalidOperation} />
    <Route path="/" component={NotFound} />
  </Switch>
);

export default routes;